
import { useUiStore } from "../stores/uiStore";

/** Immersive toolbar UI state */
export function useImmersiveUi() {
  const immersiveMode = useUiStore((s) => s.immersiveMode);
  const immersiveToolbarMinimized = useUiStore(
    (s) => s.immersiveToolbarMinimized,
  );
  const immersiveInputFocused = useUiStore((s) => s.immersiveInputFocused);
  const setImmersiveMode = useUiStore((s) => s.setImmersiveMode);
  const toggleImmersiveMode = useUiStore((s) => s.toggleImmersiveMode);
  const setImmersiveToolbarMinimized = useUiStore(
    (s) => s.setImmersiveToolbarMinimized,
  );
  const toggleImmersiveToolbarMinimized = useUiStore(
    (s) => s.toggleImmersiveToolbarMinimized,
  );
  const setImmersiveInputFocused = useUiStore((s) => s.setImmersiveInputFocused);

  return {
    immersiveMode,
    immersiveToolbarMinimized,
    immersiveInputFocused,
    setImmersiveMode,
    toggleImmersiveMode,
    setImmersiveToolbarMinimized,
    toggleImmersiveToolbarMinimized,
    setImmersiveInputFocused,
  };
}
